import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { SERVER } from 'constants/all';

import StaticLayout from 'containers/Layouts/StaticLayout/StaticLayout';

import { isDigitalQuoteDomain } from 'utils/siteUtils';

const Wrapper = styled.main`
  width: 100%;
  max-width: 900px;
  padding: 10px;
  margin: 0 auto;
  font-size: 14px;

  h1,
  pre {
    margin-bottom: 1rem;
  }

  pre {
    overflow-x: auto;
  }
`;

const ResetErrorWrapper = styled.main`
  margin-top: 50px;
  font-size: 18px;
  text-align: center;
`;

const StyledLink = styled(Link)`
  color: #0066ff;
  cursor: pointer;

  :hover {
    color: #f07f39;
    text-decoration: underline;
  }
`;

const Error = (props) => {
  const { message, statusCode, stack } = props.error;

  if (message === 'expired_password_reset_link') {
    return (
      <StaticLayout showHeader={true}>
        <ResetErrorWrapper>
          <strong role="alert">
            For security, this password reset link has expired
          </strong>
          <p>
            <StyledLink to="/reset_password">
              Click here to request a new reset link
            </StyledLink>
          </p>
        </ResetErrorWrapper>
      </StaticLayout>
    );
  } else {
    return (
      <StaticLayout showHeader={!isDigitalQuoteDomain()}>
        <Wrapper>
          <h1>Something went wrong</h1>
          {statusCode && <pre>Status code: {statusCode}</pre>}
          <pre>{message}</pre>
          {SERVER === 'local' && <pre>{stack}</pre>}
        </Wrapper>
      </StaticLayout>
    );
  }
};

export default Error;
